import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const COPY_TAB = 'COPY';
const MOVE_TAB = 'MOVE';

const styles = () => ({
  field: {
    marginBottom: '16px',
    width: '100%'
  },
  actionButton: {
    position: 'relative'
  },
  spinner: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -10,
    marginLeft: -10
  },
  tabs: {
    marginBottom: '16px'
  },
  moveInfo: {
    marginTop: '8px',
    marginBottom: '8px',
    color: 'rgba(0, 0, 0, 0.54)',
    fontStyle: 'italic'
  }
});

class CopyMoveToChannelModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: COPY_TAB,
      targetChannelId: '',
      newName: `${props.groupName}-copy`,
      copyContent: true,
      errors: {}
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.setState({
        activeTab: COPY_TAB,
        targetChannelId: '',
        newName: `${this.props.groupName}-copy`,
        copyContent: true,
        errors: {}
      });
    }
  }

  handleTabChange = (event, activeTab) => {
    this.setState({ activeTab, errors: {} });
  };

  handleChange = field => event => {
    this.setState({ [field]: event.target.value, errors: {} });
  };

  handleCheckbox = event => {
    this.setState({ copyContent: event.target.checked });
  };

  validate = () => {
    const { activeTab, targetChannelId, newName } = this.state;
    const { sourceChannelId } = this.props;
    const errors = {};
    if (
      !targetChannelId ||
      isNaN(Number(targetChannelId)) ||
      Number(targetChannelId) <= 0
    ) {
      errors.targetChannelId = 'Enter a valid channel ID';
    } else if (
      activeTab === MOVE_TAB &&
      sourceChannelId != null &&
      Number(targetChannelId) === Number(sourceChannelId)
    ) {
      errors.targetChannelId =
        'Target channel must be different from the current channel.';
    }
    if (activeTab === COPY_TAB && (!newName || !newName.trim())) {
      errors.newName = 'New name is required';
    }
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleConfirm = () => {
    if (!this.validate()) return;
    const { activeTab, targetChannelId, newName, copyContent } = this.state;
    if (activeTab === MOVE_TAB) {
      this.props.onConfirmMove(Number(targetChannelId));
    } else {
      this.props.onConfirmCopy(
        Number(targetChannelId),
        newName.trim(),
        copyContent
      );
    }
  };

  render() {
    const { open, onCancel, copying, moving, classes } = this.props;
    const {
      activeTab,
      targetChannelId,
      newName,
      copyContent,
      errors
    } = this.state;

    const isMove = activeTab === MOVE_TAB;
    const loading = isMove ? moving : copying;

    let buttonLabel = isMove ? 'Move' : 'Copy';
    if (loading) {
      buttonLabel = isMove ? 'Moving...' : 'Copying...';
    }

    return (
      <Dialog
        open={open}
        onClose={onCancel}
        aria-labelledby="copy-move-dialog-title"
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="copy-move-dialog-title">
          Copy or Move Group to Channel
        </DialogTitle>
        <DialogContent>
          <Tabs
            value={activeTab}
            onChange={this.handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            className={classes.tabs}
          >
            <Tab
              id="tab-copy"
              label="COPY"
              value={COPY_TAB}
              disabled={loading}
            />
            <Tab
              id="tab-move"
              label="MOVE"
              value={MOVE_TAB}
              disabled={loading}
            />
          </Tabs>
          <TextField
            id="targetChannelId"
            label="Target Channel ID"
            type="number"
            value={targetChannelId}
            onChange={this.handleChange('targetChannelId')}
            error={Boolean(errors.targetChannelId)}
            helperText={errors.targetChannelId}
            disabled={loading}
            className={classes.field}
            autoFocus
          />
          {!isMove && (
            <TextField
              id="newName"
              label="New Group Name"
              value={newName}
              onChange={this.handleChange('newName')}
              error={Boolean(errors.newName)}
              helperText={errors.newName}
              disabled={loading}
              className={classes.field}
            />
          )}
          {!isMove && (
            <FormControlLabel
              control={
                <Checkbox
                  id="copyContent"
                  checked={copyContent}
                  onChange={this.handleCheckbox}
                  disabled={loading}
                  color="primary"
                />
              }
              label="Maintain content associations (e.g., menu items)"
            />
          )}
          {isMove && (
            <Typography
              id="move-info"
              variant="body2"
              className={classes.moveInfo}
            >
              Moving transfers the group to the target channel. All menu item
              content stays associated and moves with it. The group will no
              longer appear in the current channel.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            id="btn-copy-move-cancel"
            onClick={onCancel}
            disabled={loading}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            id="btn-copy-move-confirm"
            onClick={this.handleConfirm}
            disabled={loading}
            color="primary"
            variant="contained"
            className={classes.actionButton}
          >
            {buttonLabel}
            {loading && (
              <CircularProgress size={20} className={classes.spinner} />
            )}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(CopyMoveToChannelModal);
